/**
 * @file useDebouncedValue.ts
 * @brief Debounces any value — used to throttle search inputs before
 *        firing a TanStack Query.
 *
 * @author DES
 * @date 26-05-2026
 */

import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
